import React from 'react';
import { Container, Button } from 'reactstrap';
import {Card, CardBody, CardHeader, CardFooter, CardImg, CardSubtitle, CardTitle, CardText} from 'reactstrap';


const Home=() => {
    return (
        <div>
            <div className='jumbotron '> 
                <h1 className='display-2'>Hello There</h1>
                <p>A platform to find all Courses to Learn.</p>
                <Container>
                    <Button color="primary">Start Learning</Button>
                </Container>
            </div>

           
            
            
        </div>
    );
}

export default Home;